export default __webpack_public_path__ + "static/media/1073.c2a83196.png";